import styled from 'styled-components';
export const Wrapper = styled.div `
  display: inline-flex;
  flex-direction: column;
  width: ${props => (props.isFullWidth ? '100%' : '16rem')};
`;
